// extracted by mini-css-extract-plugin
export default {"preview":"XEP4Q4kRBIDLhf0TcGsi"};